<template>
    <div class="text-center">
        <el-button-group>
            <el-tooltip v-if="user.isActive && user.isApproved" class="item" effect="dark" content="Actualizar Información de Usuario" placement="top-end">
                <el-button type="info" icon="el-icon-edit" size="mini" round @click="editUser"></el-button>
            </el-tooltip>
            <el-tooltip class="item" v-if="!user.isActive && user.isApproved" effect="dark" content="Activar Usuario"  placement="top-end">
                <el-button type="success" icon="el-icon-success" size="mini" round @click="activateUser()"></el-button>
            </el-tooltip>
            <el-tooltip class="item" v-if="user.isActive && user.isApproved" effect="dark" content="Desactivar Usuario"  placement="top-end">
                <el-button type="danger" icon="el-icon-error" size="mini" round @click="deactivateUser"></el-button>
            </el-tooltip>
            <el-tooltip class="item" v-if="!user.isApproved" effect="dark" content="Revisar Solicitud"  placement="top-end">
                <el-button type="warning" plain icon="fas fa-eye" plain size="mini" round @click="editUser"></el-button>
            </el-tooltip>
        </el-button-group>

    </div>
</template>

<script>
    export default {
        props: {

            user: {

                type: Object,
                required: true
            },

            index: {

                type: Number,
                required: true
            },
        },

        methods: {

            editUser() {
                this.$router.push({
                    path: '/administracion/usuarios/editar/'+ this.user.hash_id
                });
            },

            deactivateUser() {
                this.$confirm('¿Desea desactivar a este usuario?').then(confirm => {
                    axios.delete(`/api/users/${this.user.hash_id}`).then(response => {
                        if (response.data.success) {
                            this.$notify({
                                title: 'Éxito',
                                message: response.data.message,
                                type: 'success'
                            });
                            this.$emit('reload-users');
                        }
                        else {
                            this.$notify({
                                title: 'Error',
                                message: response.data.message,
                                type: 'error'
                            });
                        }
                    }).catch(_ => {
                        this.$notify({
                            title: 'Error',
                            message: 'No se pudo completar la solicitud',
                            type: 'error'
                        });
                    });
                }).catch(e => {
                    console.log(e);
                    this.$notify({
                        title: 'Aviso: ',
                        message:'No se registró ningún cambio',
                        type: 'warning'
                    });
                });
            },
            activateUser() {
                this.$confirm('¿Desea activar a este usuario?').then(confirm => {
                    axios.delete(`/api/users/${this.user.hash_id}`).then(response => {
                        if (response.data.success) {
                            this.$notify({
                                title: 'Éxito',
                                message: response.data.message,
                                type: 'success'
                            });
                            this.$emit('reload-users');
                        }
                        else {
                            this.$notify({
                                title: 'Error',
                                message: response.data.message,
                                type: 'error'
                            });
                        }
                    }).catch(_ => {
                        this.$notify({
                            title: 'Error',
                            message: 'No se pudo completar la solicitud',
                            type: 'error'
                        });
                    });
                }).catch(e => {
                    this.$notify({
                        title: 'Error',
                        message: e.data.message,
                        type: 'error'
                    });
                });
            }


        }
    }
</script>

<style scoped>
    .text-center {
        text-align: center;
    }
</style>
